module.exports = __webpack_public_path__ + "static/media/sidemenu_logo.db6d4915.jpg";